import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)
    
        const rangeValues = max - min;
        const increment = rangeValues / 3;
        const secondValue = Math.floor(min + increment);
        const thirdValue = Math.floor(min + 2 * increment);

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
            >
                <span class="ns-filter-block-name"
                    onClick={() => {
                        setActive(!active)
                    }}>
                        {facet.name}
                </span>
                {isSelected && (
                    <a href="javascript:void(0)" class="ns-filter-clear">Clear</a>
                )}

            </a>
            <div class="ns-filter-option-block-range">
                <div class="ns-sidebar-submenu ns-d-none">
                    <div class="ns-d-flex ns-justify-content-between ns-font-4">
                        <div class="ns-filter-option-range-amount flex-shrink-1">
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="ns-filter-option-range-amount-split"> - </div>
                        <div class="ns-filter-option-range-amount flex-shrink-1">
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <RangeSlider id={facet.id} />
                        <div class="ns-pips-horizontal">
                            <div class="ns-marker-horizontal" style="left: 0.00000%"></div>
                            <div class="noUi-value ns-value-horizontal" style="left: 0.00000%">{min}</div>
                            <div class="ns-marker-horizontal" style="left: 33.33333%"></div>
                            <div class="ns-value ns-value-horizontal" style="left: 33.33333%">{secondValue}</div>
                            <div class="ns-marker-horizontal" style="left: 66.66667%"></div>
                            <div class="ns-value ns-value-horizontal" style="left: 66.66667%">{thirdValue}</div>
                            <div class="ns-marker-horizontal" style="left: 100.00000%"></div>
                            <div class="ns-value ns-value-horizontal" style="left: 100.00000%">{max}</div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}
